var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 48,
    viewBox: "0 0 64 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0029L64 16.0029C64 7.17593 56.8253 -7.92866e-05 48 -7.89008e-05C39.1747 -7.8515e-05 32 7.17593 32 16.0029Z",
    fill: "#3098F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 15.9668L32 15.9668C32 24.7938 39.1747 31.9698 48 31.9698C56.8253 31.9698 64 24.7938 64 15.9668Z",
    fill: "#3098F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 47.9366L64 47.9366C64 39.1096 56.8253 31.9336 48 31.9336C39.1747 31.9336 32 39.1096 32 47.9366Z",
    fill: "#FFCC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15.8847C32 15.8774 32 15.8774 32 15.8847L22.8561 15.8774C22.8561 15.8774 22.8561 15.8774 22.8561 15.8847C22.8561 19.6646 19.7792 22.7421 16 22.7421C12.2208 22.7421 9.14389 19.6646 9.14389 15.8847C9.14389 15.8847 9.14389 15.8847 9.14389 15.8774L-6.99699e-07 15.8774C-6.99699e-07 15.8774 -6.99699e-07 15.8774 -6.99382e-07 15.8847C-3.13614e-07 24.7117 7.17466 31.8877 16 31.8877C24.8253 31.8877 32 24.7044 32 15.8847Z",
    fill: "#FE6571"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.51408e-06 47.9288L9.14389 47.936C9.14389 47.936 9.14389 47.936 9.14389 47.9288C9.14389 44.1489 12.2208 41.0714 16 41.0714C19.7792 41.0714 22.8561 44.1489 22.8561 47.9288C22.8561 47.9288 22.8561 47.9288 22.8561 47.936L32 47.936C32 47.936 32 47.936 32 47.9288C32 39.1018 24.8253 31.9258 16 31.9258C7.17466 31.9258 -4.12831e-06 39.1018 -4.51408e-06 47.9288Z",
    fill: "#082C4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColor);
export default __webpack_public_path__ + "static/media/icon-color.23cf13b2351e982e3e0ac8dc488db998.svg";
export { ForwardRef as ReactComponent };